import { render, staticRenderFns } from "./participant-section.vue?vue&type=template&id=65337565"
import script from "./participant-section.vue?vue&type=script&lang=js"
export * from "./participant-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports